import { RoleUiCatalogue } from "./RoleUiCatalogue";
import type { LoginResponse } from "../models/LoginResponse";
export function landingPage(session: LoginResponse, preferred?: string): string {
 const can=(path:string)=>{const ui=RoleUiCatalogue.find(x=>x.Path===path);return !!ui&&(session.User.IsTenantAdmin || (session.RoleUis!==undefined ? session.RoleUis.some(x=>x.Code===ui.Code) : session.Permissions.some(p=>p.toLowerCase()===ui.Legacy.toLowerCase())));};
 if(preferred&&can(preferred))return preferred;
 return RoleUiCatalogue.find(ui=>can(ui.Path))?.Path ?? "/unauthorized";
}
